import React from "react";
import "./Footer.css";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaYoutube,
  FaEnvelope,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaMobileAlt,
  FaGlobe,
  FaArrowUp,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import { useSettings } from "../../context/SettingsContext";

import unity from "../../assets/logo/unity.png";

const FooterSection = () => {
  const { globalSettings } = useSettings();

  return (
    <footer className="footer-container">
      <div className="footer-content">
        {/* Column 1: Logo & Contact */}
        <div className="footer-column">
          <div className="footer-logo">
            <div className="footer-site-logo">
              <Link to="/">
                <img
                  src={globalSettings?.logo ? globalSettings.logo : unity}
                  alt="Company Logo"
                  className="footer-logo-img"
                />
              </Link>
            </div>
          </div>
          <div className="contact-info">
            <div className="contact-item">
              <FaMapMarkerAlt className="icon" id="id-icon" />
              <span>
                Suite: 8/A&B, LilyPond Center, 3, R. K Mission Road, Motijheel,
                Dhaka-1000
              </span>
            </div>
            <div className="contact-item">
              <FaEnvelope className="icon" />
              <span>info@iconicunitygroup.com</span>
            </div>
            <div className="contact-item">
              <FaGlobe className="icon" />
              <span>www.iconicunitygroup.com</span>
            </div>
            <div className="contact-item">
              <FaMobileAlt className="icon" />
              <span>
                <strong>Hotline:</strong> 01824800900
              </span>
            </div>
            <div className="contact-item">
              <FaPhoneAlt className="icon" />
              <span>Phone: 01711183777</span>
            </div>
          </div>
        </div>

        {/* Column 2: Navigation */}
        <div className="footer-column" id="footer-column-page">
          <h3 className="footer-nav-header">Navigation</h3>
          <ul className="li-links">
            <li>
              <Link to={"/"}>Home</Link>
            </li>
            <li>
              <Link to={"/about-us"}>About</Link>
            </li>
            <li>
              <Link to={"/gallery"}>Gallery</Link>
            </li>
            <li>
              <Link to={"/blogs"}>Blogs</Link>
            </li>
            <li>
              <Link to={"/contact-us"}>Contact</Link>
            </li>
            <li>
              <Link to={"/faq"}>FAQ</Link>
            </li>
          </ul>
        </div>

        {/* Column 3: Services */}
        <div className="footer-column">
          <h3 className="footer-nav-header">Our Sister Concern</h3>
          <ul className="li-links">
            <li>
              <Link to={"https://iconicexpressbd.com/"}>Iconic Express</Link>
            </li>
            <li>
              <Link to={"https://iconicgreenland.com/"}>Iconic Greenland</Link>
            </li>
            <li>
              <Link to={"https://iconicsoftltd.com/"}>Iconic Soft</Link>
            </li>
            <li>
              <Link to={"https://iconicfurniturebd.com/"}>
                Iconic Furniture
              </Link>
            </li>
            <li>
              <Link to={"https://iconicdigitalsolution.com/"}>
                Iconic Digital Solution
              </Link>
            </li>
            {/* <li>
              <Link to={"https://iconictravelsbd.com/tour/hajj-umrah/"}>Iconic Hajj Group</Link>
            </li> */}
            <li>
              <Link to={"https://iconicmotorsltd.com/"}>Iconic Motors</Link>
            </li>
          </ul>
        </div>

        {/* Column 4: Social & QR */}
        <div className="footer-column">
          <h3 className="footer-nav-header">Social Media</h3>
          <div className="social-icons ">
            <a
              href="https://www.facebook.com/groups/1793092464521824/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              className="footer-link"
            >
              <FaFacebookF />
            </a>

            <a
              href="https://www.linkedin.com/company/iconicunitygroup"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              className="footer-link"
            >
              <FaLinkedinIn />
            </a>

            {/* <a
              href="https://twitter.com/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Twitter"
              className="footer-link"
            >
              <FaTwitter />
            </a> */}

            <a
              href="https://www.youtube.com/@iuggulshan"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
              className="footer-link"
            >
              <FaYoutube />
            </a>

            {/* <a
              href="https://www.pinterest.com/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Pinterest"
              className="footer-link"
            >
              <FaPinterestP />
            </a> */}

            <a
              href="mailto:info@iconicsoftltd.com"
              aria-label="Email"
              className="footer-link"
            >
              <FaEnvelope />
            </a>
          </div>
          <h3 className="footer-nav-header">Scan for QR</h3>
          <div className="qr-container">
            {/* Replace with actual QR image path */}
            <img src="QR.jpg" alt="" />
          </div>
          <p className="qr-text">
            To scan with your camera's default photo mode, point your camera at
            a QR code.
          </p>
        </div>
      </div>

      {/* <div>
        <BottomFooter></BottomFooter>
      </div> */}

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <div className="bottom-content">
          <p>Copyright © 2026 Iconic Unity Group. All Rights Reserved.</p>
          <div>
            Designed & Developed by{" "}
            <a
              className="footer-link"
              href="https://www.iconicsoftltd.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Iconic Soft Ltd.
            </a>
          </div>
          <div className="bottom-links">
            <a className="footer-link" href="/privacy">
              Privacy Policy
            </a>
            <a className="footer-link" href="/terms-and-conditions">
              Terms & conditions
            </a>
            <a className="footer-link" href="/sitemap">
              Sitemap
            </a>
          </div>
        </div>
        <button
          type="button"
          className="scroll-top"
          aria-label="Scroll to top"
          onClick={() =>
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            })
          }
        >
          <FaArrowUp />
        </button>
      </div>
    </footer>
  );
};

export default FooterSection;
